import React, { useState, useEffect } from "react";
import styles from "./AdminViewStudent.module.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { AxiosInstance } from "../../../../../../axios";
import { ImageUrlPrefix } from "../../../../../../labels";

function AdminViewStudent() {
  const [evaluatorAssigned, setEvaluatorAssigned] = useState(false);
  const [isDoubtEvaluator, setIsDoubtEvaluator] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { EVENTID, USER_ID, EVCOUNTS } = location.state || {};
  const { path_id } = useParams();
  const [testDetail, setTestDetail] = useState({});
  const [staffData, setStaffData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/test/descriptive/stud_view_by_admin", {
      event_id: EVENTID,
      user_id: USER_ID,
      attempt_no: EVCOUNTS ? EVCOUNTS : "",
    })
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          const datavIEW = res.data.student_data;
          const staff_data = res.data.staff_data;
          const datasa = {
            tot_no_question: datavIEW.no_of_questions,
            tot_marks: datavIEW.tot_marks,
            marks_obtained: datavIEW.marks_obtained,
            marks_in_perc: datavIEW.marks_in_perc,
            attendance_status: datavIEW.attendance_status,
            attempt_no: datavIEW.attempt_no,
            event_rank: datavIEW.event_rank,
            over_all_event_rank: datavIEW.over_all_event_rank,
            double_evaluation: datavIEW.double_evaluation,
          };
          setTestDetail(datasa);
          setStaffData(staff_data);
        } else {
          setIsLoading(false);
          setStaffData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }, [1]);
  const ratingOptions = [
    { value: "4", label: "Excellent" },
    { value: "3", label: "Good" },
    { value: "2", label: "Average" },
    { value: "1", label: "Below Average" },
    { value: "0", label: "Poor" },
  ];
  const getLabelForHandWriting = (handWriting) => {
    const rating = ratingOptions.find(
      (option) => option.value === String(handWriting)
    );
    return rating ? rating.label : "_";
  };

  return (
    <>
      <div className="container-fluid global_container BathHeader">
        <div className="row ">
          <div className=" col-md-6 col-12 ">
            <h6 className="TitleHeader "> View Student</h6>
          </div>

          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link to={-1} className="secondaryButton ">
                  {path_id !== "0"
                    ? "Back to View Evaluator"
                    : "Back to View Test"}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <fieldset className="mt-3">
            <legend className="w-auto">Overall Test Details</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    Total Number of Questions
                  </p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {testDetail.tot_no_question}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Total Marks</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {testDetail.tot_marks}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Obtained Marks</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {testDetail.marks_obtained ||
                      testDetail.marks_obtained === 0
                      ? testDetail.marks_obtained
                      : "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Class Rank</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {testDetail.event_rank || "_"}
                  </p>
                </div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Overall Rank</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {testDetail.over_all_event_rank || "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>

          {path_id === "0" &&
            staffData.length > 0 &&
            staffData[0].staff_name === null &&
            testDetail.double_evaluation === 1 && (
              <>
                <fieldset className="my-3 ">
                  <legend className="w-auto">Evaluation by Evaluator 1</legend>
                  <p className={`${styles.d_type_para} mb-0 text-center`}>
                    Not yet assigned to any evaluator yet.
                  </p>
                </fieldset>
                <fieldset className="my-3 ">
                  <legend className="w-auto">Evaluation by Evaluator 2</legend>
                  <p className={`${styles.d_type_para} mb-0 text-center`}>
                    Not yet assigned to any evaluator yet.
                  </p>
                </fieldset>
              </>
            )}

          {path_id === "0" &&
            staffData.length > 0 &&
            staffData[0].staff_name === null &&
            testDetail.double_evaluation === 0 && (
              <fieldset className="my-3 ">
                <legend className="w-auto">Evaluation by Evaluator 1</legend>
                <p className={`${styles.d_type_para} mb-0 text-center`}>
                  Not yet assigned to any evaluator yet.
                </p>
              </fieldset>
            )}

          {testDetail.double_evaluation === 0 &&
            staffData.length > 0 &&
            staffData[0].staff_name !== null &&
            staffData.map((io, index) => (
              <>
                <fieldset className="my-3 ">
                  <legend className="w-auto">
                    Evaluation by {io.staff_name || `_`}
                  </legend>

                  <div className="row mb-3">
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">Obtained Marks</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {io.marks_obtained || io.marks_obtained === 0
                            ? io.marks_obtained
                            : "_"}
                        </p>
                      </div>
                    </div>
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">Hand Writing</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {getLabelForHandWriting(io.hand_writing) || "_"}
                        </p>
                      </div>
                    </div>
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">Key Points</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {getLabelForHandWriting(io.key_points) || "_"}
                        </p>
                      </div>
                    </div>
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">Presentation</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {getLabelForHandWriting(io.presentation) || "_"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">
                          Quantity of Facts
                        </p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {getLabelForHandWriting(io.quantity_facts) || "_"}
                        </p>
                      </div>
                    </div>

                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">
                          Quality of Content
                        </p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {getLabelForHandWriting(io.quality_content) || "_"}
                        </p>
                      </div>
                    </div>
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">Pictographics</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {getLabelForHandWriting(io.pictographics) || "_"}
                        </p>
                      </div>
                    </div>
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">Headings</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {getLabelForHandWriting(io.headings) || "_"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">Sub Headings</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {getLabelForHandWriting(io.sub_heading) || "_"}
                        </p>
                      </div>
                    </div>

                    <div className="my-1 col-lg-9 col-md-9 col-12">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0 p-0">Final Comments</p>
                        <p className="confirm_value my-1 m-0 p-0">
                          {io.highlight_facts || "_"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="">
                        <label className="confirm_label m-0 p-0">
                          Evaluated Answer Sheet
                        </label>
                        {io.descriptive_answer_sheet !== null && (
                          <a
                            href={`${ImageUrlPrefix}/${io.descriptive_answer_sheet}`}
                            target="_blank"
                          >
                            <span
                              className={`${styles.mui_icon} material-icons align-middle mx-1`}
                            >
                              file_download
                            </span>
                            <span
                              class={`${styles.mui_icon} material-icons align-middle`}
                            >
                              visibility
                            </span>
                          </a>
                        )}

                        <p className="confirm_value my-1 m-0 p-0">
                          {io.descriptive_answer_sheet
                            ? io.descriptive_answer_sheet.split("/").pop()
                            : "_"}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </>
            ))}
          {path_id !== "1" &&
            testDetail.double_evaluation === 1 &&
            (staffData.length < 2 &&
              staffData.filter(
                (ui) => ui.staff_name !== null && ui.evaluator_count === 2
              ).length > 0 ? (
              <fieldset className="my-3">
                <legend className="w-auto">
                  Evaluation by Evaluator{" "}
                  {staffData.length > 0 && staffData[0].evaluator_count - 1}
                </legend>
                <p className={`${styles.d_type_para} mb-0 text-center`}>
                  Not yet assigned to any evaluator yet.
                </p>
              </fieldset>
            ) : null)}

          {testDetail.double_evaluation === 1 &&
            staffData.length > 0 &&
            staffData[0].staff_name !== null &&
            staffData
              .sort((a, b) => {
                return a.evaluator_count - b.evaluator_count;
              })
              .map((io, index) => (
                <>
                  <fieldset className="my-3 ">
                    <legend className="w-auto">
                      Evaluation by {io.staff_name || `_`}
                    </legend>
                    {/* comments fields to add the update marks column change*/}
                    <div className="row mb-3">
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">
                            Obtained Marks
                          </p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {io.marks_obtained || io.marks_obtained === 0
                              ? io.marks_obtained
                              : "_"}
                          </p>
                        </div>
                      </div>
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Hand Writing</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {getLabelForHandWriting(io.hand_writing) || "_"}
                          </p>
                        </div>
                      </div>
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Key Points</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {getLabelForHandWriting(io.key_points) || "_"}
                          </p>
                        </div>
                      </div>
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Presentation</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {getLabelForHandWriting(io.presentation) || "_"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">
                            Quantity of Facts
                          </p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {getLabelForHandWriting(io.quantity_facts) || "_"}
                          </p>
                        </div>
                      </div>
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">
                            Quality of Content
                          </p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {getLabelForHandWriting(io.quality_content) || "_"}
                          </p>
                        </div>
                      </div>
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Pictographics</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {getLabelForHandWriting(io.pictographics) || "_"}
                          </p>
                        </div>
                      </div>
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Headings</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {getLabelForHandWriting(io.headings) || "_"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">Sub Headings</p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {getLabelForHandWriting(io.sub_heading) || "_"}
                          </p>
                        </div>
                      </div>
                      <div className="my-1 col-lg-9 col-md-9 col-12">
                        <div className="d-flex flex-column">
                          <p className="confirm_label m-0 p-0">
                            Final Comments
                          </p>
                          <p className="confirm_value my-1 m-0 p-0">
                            {io.highlight_facts || "_"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="my-1 col-lg-3 col-md-3 col-12">
                        <div className="">
                          <label className="confirm_label m-0 p-0">
                            Evaluated Answer Sheet
                          </label>
                          {io.descriptive_answer_sheet !== null && (
                            <a
                              href={`${ImageUrlPrefix}/${io.descriptive_answer_sheet}`}
                              target="_blank"
                            >
                              <span
                                className={`${styles.mui_icon} material-icons align-middle mx-1`}
                              >
                                file_download
                              </span>
                              <span
                                class={`${styles.mui_icon} material-icons align-middle`}
                              >
                                visibility
                              </span>
                            </a>
                          )}
                          <p className="confirm_value my-1 m-0 p-0">
                            {io.descriptive_answer_sheet
                              ? io.descriptive_answer_sheet_original_path
                              : "_"}{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </>
              ))}

          {path_id !== "1" &&
            testDetail.double_evaluation === 1 &&
            (staffData.length < 2 &&
              staffData.filter(
                (ui) => ui.staff_name !== null && ui.evaluator_count === 1
              ).length > 0 ? (
              <fieldset className="my-3">
                <legend className="w-auto">
                  Evaluation by Evaluator{" "}
                  {staffData.length > 0 && staffData[0].evaluator_count + 1}
                </legend>
                <p className={`${styles.d_type_para} mb-0 text-center`}>
                  Not yet assigned to any evaluator yet.
                </p>
              </fieldset>
            ) : null)}
        </div>
      </div>
    </>
  );
}

export default AdminViewStudent;
